// extracted by css-extract-rspack-plugin
export default {"spaceXSmall":"8px","spaceSmall":"12px","ctaInline":"task-cta-buttons__ctaInline___gA54j"};